import { Checkbox } from '@/shared/components/shadcn/checkbox';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/shadcn/tooltip';
import { TooltipFlat } from '@/shared/components/shadcn/tooltip/tooltip-flat';
import { trackEvent } from '@/shared/track';

export const CreatorsResultsListActions = ({
  toggleAll,
  isAllSelected,
  isSearchComplete,
  searchId,
}: {
  isAllSelected: boolean;
  toggleAll: () => void;
  sortBy: 'ai-match' | 'engagement-rate';
  setSortBy: (sortBy: 'ai-match' | 'engagement-rate') => void;
  isSearchComplete: boolean;
  searchId: string;
}) => {
  return (
    <div className="text-muted bg-accent border-b px-6 py-2.5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-5">
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="flex items-center gap-2">
                <Checkbox
                  checked={isAllSelected}
                  onCheckedChange={() => {
                    trackEvent('Creator', 'toggle_select_all', {
                      search_id: searchId,
                    });
                    toggleAll();
                  }}
                  className="h-5 w-5"
                  disabled={!isSearchComplete}
                />
                <label
                  className="text-foreground text-sm font-normal"
                  onClick={() => {
                    if (!isSearchComplete) return;
                    trackEvent('Creator', 'toggle_select_all', {
                      search_id: searchId,
                    });
                    toggleAll();
                  }}
                >
                  Select all
                </label>
              </span>
            </TooltipTrigger>
            {!isSearchComplete && (
              <TooltipContent>Wait until the search finishes to select all results.</TooltipContent>
            )}
          </Tooltip>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-muted-foreground text-sm font-normal">Sort by</span>
          <TooltipFlat
            triggerClassName="text-foreground bg-background rounded-sm border px-4 py-2 text-sm"
            content="Creators matching your search are added as each round of results is verified"
          >
            As discovered
          </TooltipFlat>
          {/* <Select
            value={sortBy}
            onValueChange={(value: 'ai-match' | 'engagement-rate') => setSortBy(value)}
          >
            <SelectTrigger className="bg-background text-primary h-8 w-40">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="ai-match">
                
              </SelectItem>
              <SelectItem value="engagement-rate" disabled>
                Engagement rate
              </SelectItem>
            </SelectContent>
          </Select> */}
        </div>
      </div>
    </div>
  );
};
